import React from "react";
import Dialog from "src/components/Dialog";
import { withTranslation } from "react-i18next";
import { ReactComponent as VideoIcon } from "./video.svg";

function VideoIsSlowDialog({ t, isOpen, onDismiss }) {
  return (
    <Dialog
      icon={VideoIcon}
      iconBg="warningLight"
      fill="warningBase"
      heading={t("parentStation.videoErrors.videoIsSlowDialog.heading")}
      text={t("parentStation.videoErrors.videoIsSlowDialog.text")}
      isOpen={isOpen}
      buttons={[{ text: t("buttons.ok"), onClick: onDismiss }]}
    />
  );
}

export default withTranslation()(VideoIsSlowDialog);
